import { computed } from "vue";
import { useColorMode, useStorage } from "@vueuse/core";

export type ThemeMode = "light" | "dark" | "system";

export function useThemePreference() {
  const storedMode = useStorage<ThemeMode>("seeft-app-theme", "dark");
  const colorMode = useColorMode({
    attribute: "class",
    initialValue: storedMode.value === "system" ? "auto" : storedMode.value,
    modes: {
      light: "light",
      dark: "dark"
    }
  });

  const currentMode = computed<ThemeMode>(() => {
    if (storedMode.value === "system") {
      return "system";
    }

    return colorMode.value === "auto" ? "system" : (colorMode.value as ThemeMode);
  });

  async function setThemeMode(mode: ThemeMode) {
    storedMode.value = mode;
    colorMode.value = mode === "system" ? "auto" : mode;
  }

  function getCurrentMode() {
    return currentMode.value;
  }

  return {
    currentMode,
    getCurrentMode,
    setThemeMode
  };
}
